/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as InventoryRouteImport } from './routes/inventory'
import { Route as LoansRouteImport } from './routes/loans'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PurchasesRouteImport } from './routes/purchases'
import { Route as ReportsRouteImport } from './routes/reports'
import { Route as ReturnsRouteImport } from './routes/returns'
import { Route as SalesRouteImport } from './routes/sales'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SigninRouteImport } from './routes/signin'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as VerifyOtpRouteImport } from './routes/verify-otp'
import { Route as WalletRouteImport } from './routes/wallet'
import { Route as AdminAmlRouteImport } from './routes/admin_.aml'
import { Route as AdminApprovalsRouteImport } from './routes/admin_.approvals'
import { Route as AdminCustomersRouteImport } from './routes/admin_.customers'
import { Route as AdminFraudRouteImport } from './routes/admin_.fraud'
import { Route as AdminKycRouteImport } from './routes/admin_.kyc'
import { Route as AdminLoansRouteImport } from './routes/admin_.loans'
import { Route as AdminSettingsRouteImport } from './routes/admin_.settings'
import { Route as InventoryItemIdRouteImport } from './routes/inventory_.$itemId'
import { Route as InventoryCategoriesRouteImport } from './routes/inventory_.categories'
import { Route as InventoryNewRouteImport } from './routes/inventory_.new'
import { Route as InviteTokenRouteImport } from './routes/invite.$token'
import { Route as LoansIdRouteImport } from './routes/loans_.$id'
import { Route as PayStoreIdRouteImport } from './routes/pay.$storeId'
import { Route as PurchasesNewRouteImport } from './routes/purchases_.new'
import { Route as RTokenRouteImport } from './routes/r.$token'
import { Route as SalesSaleIdRouteImport } from './routes/sales_.$saleId'
import { Route as SalesNewRouteImport } from './routes/sales_.new'
import { Route as WalletStatementRouteImport } from './routes/wallet_.statement'
import { Route as AdminKycIdRouteImport } from './routes/admin_.kyc_.$id'
import { Route as InventoryNewProductRouteImport } from './routes/inventory_.new_.product'
import { Route as InventoryNewServiceRouteImport } from './routes/inventory_.new_.service'
import { Route as KycCaptureTokenRouteImport } from './routes/kyc_.capture.$token'
import { Route as LoansApplyStepRouteImport } from './routes/loans_.apply.$step'
import { Route as AdminCustomersIdTransactionsRouteImport } from './routes/admin_.customers_.$id.transactions'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const InventoryRoute = InventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => rootRouteImport,
} as any)
const LoansRoute = LoansRouteImport.update({
  id: '/loans',
  path: '/loans',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const PurchasesRoute = PurchasesRouteImport.update({
  id: '/purchases',
  path: '/purchases',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsRoute = ReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const ReturnsRoute = ReturnsRouteImport.update({
  id: '/returns',
  path: '/returns',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesRoute = SalesRouteImport.update({
  id: '/sales',
  path: '/sales',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SigninRoute = SigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyOtpRoute = VerifyOtpRouteImport.update({
  id: '/verify-otp',
  path: '/verify-otp',
  getParentRoute: () => rootRouteImport,
} as any)
const WalletRoute = WalletRouteImport.update({
  id: '/wallet',
  path: '/wallet',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAmlRoute = AdminAmlRouteImport.update({
  id: '/admin_/aml',
  path: '/admin/aml',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminApprovalsRoute = AdminApprovalsRouteImport.update({
  id: '/admin_/approvals',
  path: '/admin/approvals',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminCustomersRoute = AdminCustomersRouteImport.update({
  id: '/admin_/customers',
  path: '/admin/customers',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminFraudRoute = AdminFraudRouteImport.update({
  id: '/admin_/fraud',
  path: '/admin/fraud',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminKycRoute = AdminKycRouteImport.update({
  id: '/admin_/kyc',
  path: '/admin/kyc',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminLoansRoute = AdminLoansRouteImport.update({
  id: '/admin_/loans',
  path: '/admin/loans',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/admin_/settings',
  path: '/admin/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const InventoryItemIdRoute = InventoryItemIdRouteImport.update({
  id: '/inventory_/$itemId',
  path: '/inventory/$itemId',
  getParentRoute: () => rootRouteImport,
} as any)
const InventoryCategoriesRoute = InventoryCategoriesRouteImport.update({
  id: '/inventory_/categories',
  path: '/inventory/categories',
  getParentRoute: () => rootRouteImport,
} as any)
const InventoryNewRoute = InventoryNewRouteImport.update({
  id: '/inventory_/new',
  path: '/inventory/new',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const LoansIdRoute = LoansIdRouteImport.update({
  id: '/loans_/$id',
  path: '/loans/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const PayStoreIdRoute = PayStoreIdRouteImport.update({
  id: '/pay/$storeId',
  path: '/pay/$storeId',
  getParentRoute: () => rootRouteImport,
} as any)
const PurchasesNewRoute = PurchasesNewRouteImport.update({
  id: '/purchases_/new',
  path: '/purchases/new',
  getParentRoute: () => rootRouteImport,
} as any)
const RTokenRoute = RTokenRouteImport.update({
  id: '/r/$token',
  path: '/r/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesSaleIdRoute = SalesSaleIdRouteImport.update({
  id: '/sales_/$saleId',
  path: '/sales/$saleId',
  getParentRoute: () => rootRouteImport,
} as any)
const SalesNewRoute = SalesNewRouteImport.update({
  id: '/sales_/new',
  path: '/sales/new',
  getParentRoute: () => rootRouteImport,
} as any)
const WalletStatementRoute = WalletStatementRouteImport.update({
  id: '/wallet_/statement',
  path: '/wallet/statement',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminKycIdRoute = AdminKycIdRouteImport.update({
  id: '/admin_/kyc_/$id',
  path: '/admin/kyc/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const InventoryNewProductRoute = InventoryNewProductRouteImport.update({
  id: '/inventory_/new_/product',
  path: '/inventory/new/product',
  getParentRoute: () => rootRouteImport,
} as any)
const InventoryNewServiceRoute = InventoryNewServiceRouteImport.update({
  id: '/inventory_/new_/service',
  path: '/inventory/new/service',
  getParentRoute: () => rootRouteImport,
} as any)
const KycCaptureTokenRoute = KycCaptureTokenRouteImport.update({
  id: '/kyc_/capture/$token',
  path: '/kyc/capture/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const LoansApplyStepRoute = LoansApplyStepRouteImport.update({
  id: '/loans_/apply/$step',
  path: '/loans/apply/$step',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminCustomersIdTransactionsRoute =
  AdminCustomersIdTransactionsRouteImport.update({
    id: '/admin_/customers_/$id/transactions',
    path: '/admin/customers/$id/transactions',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/dashboard': typeof DashboardRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/inventory': typeof InventoryRoute
  '/loans': typeof LoansRoute
  '/onboarding': typeof OnboardingRoute
  '/privacy': typeof PrivacyRoute
  '/purchases': typeof PurchasesRoute
  '/reports': typeof ReportsRoute
  '/returns': typeof ReturnsRoute
  '/sales': typeof SalesRoute
  '/settings': typeof SettingsRoute
  '/signin': typeof SigninRoute
  '/signup': typeof SignupRoute
  '/terms': typeof TermsRoute
  '/verify-otp': typeof VerifyOtpRoute
  '/wallet': typeof WalletRoute
  '/admin/aml': typeof AdminAmlRoute
  '/admin/approvals': typeof AdminApprovalsRoute
  '/admin/customers': typeof AdminCustomersRoute
  '/admin/fraud': typeof AdminFraudRoute
  '/admin/kyc': typeof AdminKycRoute
  '/admin/loans': typeof AdminLoansRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/inventory/$itemId': typeof InventoryItemIdRoute
  '/inventory/categories': typeof InventoryCategoriesRoute
  '/inventory/new': typeof InventoryNewRoute
  '/invite/$token': typeof InviteTokenRoute
  '/loans/$id': typeof LoansIdRoute
  '/pay/$storeId': typeof PayStoreIdRoute
  '/purchases/new': typeof PurchasesNewRoute
  '/r/$token': typeof RTokenRoute
  '/sales/$saleId': typeof SalesSaleIdRoute
  '/sales/new': typeof SalesNewRoute
  '/wallet/statement': typeof WalletStatementRoute
  '/admin/kyc/$id': typeof AdminKycIdRoute
  '/inventory/new/product': typeof InventoryNewProductRoute
  '/inventory/new/service': typeof InventoryNewServiceRoute
  '/kyc/capture/$token': typeof KycCaptureTokenRoute
  '/loans/apply/$step': typeof LoansApplyStepRoute
  '/admin/customers/$id/transactions': typeof AdminCustomersIdTransactionsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/dashboard': typeof DashboardRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/inventory': typeof InventoryRoute
  '/loans': typeof LoansRoute
  '/onboarding': typeof OnboardingRoute
  '/privacy': typeof PrivacyRoute
  '/purchases': typeof PurchasesRoute
  '/reports': typeof ReportsRoute
  '/returns': typeof ReturnsRoute
  '/sales': typeof SalesRoute
  '/settings': typeof SettingsRoute
  '/signin': typeof SigninRoute
  '/signup': typeof SignupRoute
  '/terms': typeof TermsRoute
  '/verify-otp': typeof VerifyOtpRoute
  '/wallet': typeof WalletRoute
  '/admin/aml': typeof AdminAmlRoute
  '/admin/approvals': typeof AdminApprovalsRoute
  '/admin/customers': typeof AdminCustomersRoute
  '/admin/fraud': typeof AdminFraudRoute
  '/admin/kyc': typeof AdminKycRoute
  '/admin/loans': typeof AdminLoansRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/inventory/$itemId': typeof InventoryItemIdRoute
  '/inventory/categories': typeof InventoryCategoriesRoute
  '/inventory/new': typeof InventoryNewRoute
  '/invite/$token': typeof InviteTokenRoute
  '/loans/$id': typeof LoansIdRoute
  '/pay/$storeId': typeof PayStoreIdRoute
  '/purchases/new': typeof PurchasesNewRoute
  '/r/$token': typeof RTokenRoute
  '/sales/$saleId': typeof SalesSaleIdRoute
  '/sales/new': typeof SalesNewRoute
  '/wallet/statement': typeof WalletStatementRoute
  '/admin/kyc/$id': typeof AdminKycIdRoute
  '/inventory/new/product': typeof InventoryNewProductRoute
  '/inventory/new/service': typeof InventoryNewServiceRoute
  '/kyc/capture/$token': typeof KycCaptureTokenRoute
  '/loans/apply/$step': typeof LoansApplyStepRoute
  '/admin/customers/$id/transactions': typeof AdminCustomersIdTransactionsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/dashboard': typeof DashboardRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/inventory': typeof InventoryRoute
  '/loans': typeof LoansRoute
  '/onboarding': typeof OnboardingRoute
  '/privacy': typeof PrivacyRoute
  '/purchases': typeof PurchasesRoute
  '/reports': typeof ReportsRoute
  '/returns': typeof ReturnsRoute
  '/sales': typeof SalesRoute
  '/settings': typeof SettingsRoute
  '/signin': typeof SigninRoute
  '/signup': typeof SignupRoute
  '/terms': typeof TermsRoute
  '/verify-otp': typeof VerifyOtpRoute
  '/wallet': typeof WalletRoute
  '/admin_/aml': typeof AdminAmlRoute
  '/admin_/approvals': typeof AdminApprovalsRoute
  '/admin_/customers': typeof AdminCustomersRoute
  '/admin_/fraud': typeof AdminFraudRoute
  '/admin_/kyc': typeof AdminKycRoute
  '/admin_/loans': typeof AdminLoansRoute
  '/admin_/settings': typeof AdminSettingsRoute
  '/inventory_/$itemId': typeof InventoryItemIdRoute
  '/inventory_/categories': typeof InventoryCategoriesRoute
  '/inventory_/new': typeof InventoryNewRoute
  '/invite/$token': typeof InviteTokenRoute
  '/loans_/$id': typeof LoansIdRoute
  '/pay/$storeId': typeof PayStoreIdRoute
  '/purchases_/new': typeof PurchasesNewRoute
  '/r/$token': typeof RTokenRoute
  '/sales_/$saleId': typeof SalesSaleIdRoute
  '/sales_/new': typeof SalesNewRoute
  '/wallet_/statement': typeof WalletStatementRoute
  '/admin_/kyc_/$id': typeof AdminKycIdRoute
  '/inventory_/new_/product': typeof InventoryNewProductRoute
  '/inventory_/new_/service': typeof InventoryNewServiceRoute
  '/kyc_/capture/$token': typeof KycCaptureTokenRoute
  '/loans_/apply/$step': typeof LoansApplyStepRoute
  '/admin_/customers_/$id/transactions': typeof AdminCustomersIdTransactionsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/dashboard'
    | '/forgot-password'
    | '/inventory'
    | '/loans'
    | '/onboarding'
    | '/privacy'
    | '/purchases'
    | '/reports'
    | '/returns'
    | '/sales'
    | '/settings'
    | '/signin'
    | '/signup'
    | '/terms'
    | '/verify-otp'
    | '/wallet'
    | '/admin/aml'
    | '/admin/approvals'
    | '/admin/customers'
    | '/admin/fraud'
    | '/admin/kyc'
    | '/admin/loans'
    | '/admin/settings'
    | '/inventory/$itemId'
    | '/inventory/categories'
    | '/inventory/new'
    | '/invite/$token'
    | '/loans/$id'
    | '/pay/$storeId'
    | '/purchases/new'
    | '/r/$token'
    | '/sales/$saleId'
    | '/sales/new'
    | '/wallet/statement'
    | '/admin/kyc/$id'
    | '/inventory/new/product'
    | '/inventory/new/service'
    | '/kyc/capture/$token'
    | '/loans/apply/$step'
    | '/admin/customers/$id/transactions'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/dashboard'
    | '/forgot-password'
    | '/inventory'
    | '/loans'
    | '/onboarding'
    | '/privacy'
    | '/purchases'
    | '/reports'
    | '/returns'
    | '/sales'
    | '/settings'
    | '/signin'
    | '/signup'
    | '/terms'
    | '/verify-otp'
    | '/wallet'
    | '/admin/aml'
    | '/admin/approvals'
    | '/admin/customers'
    | '/admin/fraud'
    | '/admin/kyc'
    | '/admin/loans'
    | '/admin/settings'
    | '/inventory/$itemId'
    | '/inventory/categories'
    | '/inventory/new'
    | '/invite/$token'
    | '/loans/$id'
    | '/pay/$storeId'
    | '/purchases/new'
    | '/r/$token'
    | '/sales/$saleId'
    | '/sales/new'
    | '/wallet/statement'
    | '/admin/kyc/$id'
    | '/inventory/new/product'
    | '/inventory/new/service'
    | '/kyc/capture/$token'
    | '/loans/apply/$step'
    | '/admin/customers/$id/transactions'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/dashboard'
    | '/forgot-password'
    | '/inventory'
    | '/loans'
    | '/onboarding'
    | '/privacy'
    | '/purchases'
    | '/reports'
    | '/returns'
    | '/sales'
    | '/settings'
    | '/signin'
    | '/signup'
    | '/terms'
    | '/verify-otp'
    | '/wallet'
    | '/admin_/aml'
    | '/admin_/approvals'
    | '/admin_/customers'
    | '/admin_/fraud'
    | '/admin_/kyc'
    | '/admin_/loans'
    | '/admin_/settings'
    | '/inventory_/$itemId'
    | '/inventory_/categories'
    | '/inventory_/new'
    | '/invite/$token'
    | '/loans_/$id'
    | '/pay/$storeId'
    | '/purchases_/new'
    | '/r/$token'
    | '/sales_/$saleId'
    | '/sales_/new'
    | '/wallet_/statement'
    | '/admin_/kyc_/$id'
    | '/inventory_/new_/product'
    | '/inventory_/new_/service'
    | '/kyc_/capture/$token'
    | '/loans_/apply/$step'
    | '/admin_/customers_/$id/transactions'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRoute
  DashboardRoute: typeof DashboardRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  InventoryRoute: typeof InventoryRoute
  LoansRoute: typeof LoansRoute
  OnboardingRoute: typeof OnboardingRoute
  PrivacyRoute: typeof PrivacyRoute
  PurchasesRoute: typeof PurchasesRoute
  ReportsRoute: typeof ReportsRoute
  ReturnsRoute: typeof ReturnsRoute
  SalesRoute: typeof SalesRoute
  SettingsRoute: typeof SettingsRoute
  SigninRoute: typeof SigninRoute
  SignupRoute: typeof SignupRoute
  TermsRoute: typeof TermsRoute
  VerifyOtpRoute: typeof VerifyOtpRoute
  WalletRoute: typeof WalletRoute
  AdminAmlRoute: typeof AdminAmlRoute
  AdminApprovalsRoute: typeof AdminApprovalsRoute
  AdminCustomersRoute: typeof AdminCustomersRoute
  AdminFraudRoute: typeof AdminFraudRoute
  AdminKycRoute: typeof AdminKycRoute
  AdminLoansRoute: typeof AdminLoansRoute
  AdminSettingsRoute: typeof AdminSettingsRoute
  InventoryItemIdRoute: typeof InventoryItemIdRoute
  InventoryCategoriesRoute: typeof InventoryCategoriesRoute
  InventoryNewRoute: typeof InventoryNewRoute
  InviteTokenRoute: typeof InviteTokenRoute
  LoansIdRoute: typeof LoansIdRoute
  PayStoreIdRoute: typeof PayStoreIdRoute
  PurchasesNewRoute: typeof PurchasesNewRoute
  RTokenRoute: typeof RTokenRoute
  SalesSaleIdRoute: typeof SalesSaleIdRoute
  SalesNewRoute: typeof SalesNewRoute
  WalletStatementRoute: typeof WalletStatementRoute
  AdminKycIdRoute: typeof AdminKycIdRoute
  InventoryNewProductRoute: typeof InventoryNewProductRoute
  InventoryNewServiceRoute: typeof InventoryNewServiceRoute
  KycCaptureTokenRoute: typeof KycCaptureTokenRoute
  LoansApplyStepRoute: typeof LoansApplyStepRoute
  AdminCustomersIdTransactionsRoute: typeof AdminCustomersIdTransactionsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory': {
      id: '/inventory'
      path: '/inventory'
      fullPath: '/inventory'
      preLoaderRoute: typeof InventoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/loans': {
      id: '/loans'
      path: '/loans'
      fullPath: '/loans'
      preLoaderRoute: typeof LoansRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/purchases': {
      id: '/purchases'
      path: '/purchases'
      fullPath: '/purchases'
      preLoaderRoute: typeof PurchasesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports': {
      id: '/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof ReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/returns': {
      id: '/returns'
      path: '/returns'
      fullPath: '/returns'
      preLoaderRoute: typeof ReturnsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales': {
      id: '/sales'
      path: '/sales'
      fullPath: '/sales'
      preLoaderRoute: typeof SalesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signin': {
      id: '/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof SigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-otp': {
      id: '/verify-otp'
      path: '/verify-otp'
      fullPath: '/verify-otp'
      preLoaderRoute: typeof VerifyOtpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/wallet': {
      id: '/wallet'
      path: '/wallet'
      fullPath: '/wallet'
      preLoaderRoute: typeof WalletRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin_/aml': {
      id: '/admin_/aml'
      path: '/admin/aml'
      fullPath: '/admin/aml'
      preLoaderRoute: typeof AdminAmlRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin_/approvals': {
      id: '/admin_/approvals'
      path: '/admin/approvals'
      fullPath: '/admin/approvals'
      preLoaderRoute: typeof AdminApprovalsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin_/customers': {
      id: '/admin_/customers'
      path: '/admin/customers'
      fullPath: '/admin/customers'
      preLoaderRoute: typeof AdminCustomersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin_/fraud': {
      id: '/admin_/fraud'
      path: '/admin/fraud'
      fullPath: '/admin/fraud'
      preLoaderRoute: typeof AdminFraudRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin_/kyc': {
      id: '/admin_/kyc'
      path: '/admin/kyc'
      fullPath: '/admin/kyc'
      preLoaderRoute: typeof AdminKycRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin_/loans': {
      id: '/admin_/loans'
      path: '/admin/loans'
      fullPath: '/admin/loans'
      preLoaderRoute: typeof AdminLoansRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin_/settings': {
      id: '/admin_/settings'
      path: '/admin/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory_/$itemId': {
      id: '/inventory_/$itemId'
      path: '/inventory/$itemId'
      fullPath: '/inventory/$itemId'
      preLoaderRoute: typeof InventoryItemIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory_/categories': {
      id: '/inventory_/categories'
      path: '/inventory/categories'
      fullPath: '/inventory/categories'
      preLoaderRoute: typeof InventoryCategoriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory_/new': {
      id: '/inventory_/new'
      path: '/inventory/new'
      fullPath: '/inventory/new'
      preLoaderRoute: typeof InventoryNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/loans_/$id': {
      id: '/loans_/$id'
      path: '/loans/$id'
      fullPath: '/loans/$id'
      preLoaderRoute: typeof LoansIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pay/$storeId': {
      id: '/pay/$storeId'
      path: '/pay/$storeId'
      fullPath: '/pay/$storeId'
      preLoaderRoute: typeof PayStoreIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/purchases_/new': {
      id: '/purchases_/new'
      path: '/purchases/new'
      fullPath: '/purchases/new'
      preLoaderRoute: typeof PurchasesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/r/$token': {
      id: '/r/$token'
      path: '/r/$token'
      fullPath: '/r/$token'
      preLoaderRoute: typeof RTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales_/$saleId': {
      id: '/sales_/$saleId'
      path: '/sales/$saleId'
      fullPath: '/sales/$saleId'
      preLoaderRoute: typeof SalesSaleIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sales_/new': {
      id: '/sales_/new'
      path: '/sales/new'
      fullPath: '/sales/new'
      preLoaderRoute: typeof SalesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/wallet_/statement': {
      id: '/wallet_/statement'
      path: '/wallet/statement'
      fullPath: '/wallet/statement'
      preLoaderRoute: typeof WalletStatementRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin_/kyc_/$id': {
      id: '/admin_/kyc_/$id'
      path: '/admin/kyc/$id'
      fullPath: '/admin/kyc/$id'
      preLoaderRoute: typeof AdminKycIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory_/new_/product': {
      id: '/inventory_/new_/product'
      path: '/inventory/new/product'
      fullPath: '/inventory/new/product'
      preLoaderRoute: typeof InventoryNewProductRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory_/new_/service': {
      id: '/inventory_/new_/service'
      path: '/inventory/new/service'
      fullPath: '/inventory/new/service'
      preLoaderRoute: typeof InventoryNewServiceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kyc_/capture/$token': {
      id: '/kyc_/capture/$token'
      path: '/kyc/capture/$token'
      fullPath: '/kyc/capture/$token'
      preLoaderRoute: typeof KycCaptureTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/loans_/apply/$step': {
      id: '/loans_/apply/$step'
      path: '/loans/apply/$step'
      fullPath: '/loans/apply/$step'
      preLoaderRoute: typeof LoansApplyStepRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin_/customers_/$id/transactions': {
      id: '/admin_/customers_/$id/transactions'
      path: '/admin/customers/$id/transactions'
      fullPath: '/admin/customers/$id/transactions'
      preLoaderRoute: typeof AdminCustomersIdTransactionsRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRoute,
  DashboardRoute: DashboardRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  InventoryRoute: InventoryRoute,
  LoansRoute: LoansRoute,
  OnboardingRoute: OnboardingRoute,
  PrivacyRoute: PrivacyRoute,
  PurchasesRoute: PurchasesRoute,
  ReportsRoute: ReportsRoute,
  ReturnsRoute: ReturnsRoute,
  SalesRoute: SalesRoute,
  SettingsRoute: SettingsRoute,
  SigninRoute: SigninRoute,
  SignupRoute: SignupRoute,
  TermsRoute: TermsRoute,
  VerifyOtpRoute: VerifyOtpRoute,
  WalletRoute: WalletRoute,
  AdminAmlRoute: AdminAmlRoute,
  AdminApprovalsRoute: AdminApprovalsRoute,
  AdminCustomersRoute: AdminCustomersRoute,
  AdminFraudRoute: AdminFraudRoute,
  AdminKycRoute: AdminKycRoute,
  AdminLoansRoute: AdminLoansRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  InventoryItemIdRoute: InventoryItemIdRoute,
  InventoryCategoriesRoute: InventoryCategoriesRoute,
  InventoryNewRoute: InventoryNewRoute,
  InviteTokenRoute: InviteTokenRoute,
  LoansIdRoute: LoansIdRoute,
  PayStoreIdRoute: PayStoreIdRoute,
  PurchasesNewRoute: PurchasesNewRoute,
  RTokenRoute: RTokenRoute,
  SalesSaleIdRoute: SalesSaleIdRoute,
  SalesNewRoute: SalesNewRoute,
  WalletStatementRoute: WalletStatementRoute,
  AdminKycIdRoute: AdminKycIdRoute,
  InventoryNewProductRoute: InventoryNewProductRoute,
  InventoryNewServiceRoute: InventoryNewServiceRoute,
  KycCaptureTokenRoute: KycCaptureTokenRoute,
  LoansApplyStepRoute: LoansApplyStepRoute,
  AdminCustomersIdTransactionsRoute: AdminCustomersIdTransactionsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
